const getSearchableRoutes = state => {
    return state.searchableRoutes;
};

export default {
    getSearchableRoutes,
};
